import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-chip-selector',
  templateUrl: './formly-chip-selector.component.html',
  styleUrls: [],
})
export class FormlyChipSelectorComponent extends FieldType {}
